import cx from 'clsx';
import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';

import { ReactComponent as ArrowIcon } from '@assets/svg/ic-aiNavArrow.svg';

import useTranslation from '@hooks/useTranslation';

import { useAdjasentSensorListQuery } from '@services/useAdjacentSensorListQuery';

import style from './style.module.scss';

const SensorNavigation: React.FC = () => {
  const { customerId, pointId } = useParams();

  const { data: adjSensorList } = useAdjasentSensorListQuery({ pointId: +pointId! });
  const { t } = useTranslation();

  if (!adjSensorList?.total || adjSensorList?.total === 1) {
    return null;
  }

  return (
    <>
      <div className={style.navigationBlock}>
        <div className={style.navigationCounter}>
          {adjSensorList?.currentIndex} {t('of')} {adjSensorList?.total}
        </div>
        <Link
          to={`/customer/${customerId}/equipment-details/sensor/${adjSensorList?.previous?.id}`}
          state={{ prevPage: true }}
          className={cx(style.navigatePrev, { [style.disabledLink]: !adjSensorList?.previous?.id })}
          data-tooltip-content={adjSensorList?.previous?.name}
          data-tooltip-id="sensor-list-navigation"
        >
          <ArrowIcon />
        </Link>
        <Link
          to={`/customer/${customerId}/equipment-details/sensor/${adjSensorList?.next?.id}`}
          state={{ prevPage: true }}
          className={cx(style.navigateNext, { [style.disabledLink]: !adjSensorList?.next?.id })}
          data-tooltip-content={adjSensorList?.next?.name}
          data-tooltip-id="sensor-list-navigation"
        >
          <ArrowIcon />
        </Link>
      </div>
      <span className={style.separator} />
      <Tooltip id="sensor-list-navigation" className={style.tooltip} />
    </>
  );
};

export default SensorNavigation;
